<template>
  <a-form :model="form" layout="vertical" class="ml-5 mt-10">
    <a-row :gutter="20">
      <a-col :span="20">
        <a-form-item label="Title">
          <a-input v-model:value="form.title" placeholder="Title" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="20">
        <a-form-item label="Subtitle">
          <a-textarea
            v-model:value="form.subtitle"
            placeholder="Subtitle"
            :rows="6"
          />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
export default {
  components: {},
  props: {
    modelValue: Object,
  },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
    };
  },
  computed: {
    form: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit("update:modelValue", newValue);
      },
    },
  },
};
</script>

<style></style>
